import React, { useMemo } from "react";
import { EditRequestButton, ScannerNotesButton } from "../../utils";
import { PeekDivider, PeekStack } from "@piiqtechnologies/ui-components";
import { ScanRequestStatus } from "@piiqtechnologies/ui-lib";
import ScanRequestHistoryPopup from "../request-history/ScanRequestHistoryPopup";
export const ScanRequestActionCell = ({ scanRequest }) => {
    const editRequestAvailable = useMemo(() => scanRequest.status !== ScanRequestStatus.SKIPPED &&
        scanRequest.status !== ScanRequestStatus.CANCELED &&
        scanRequest.status !== ScanRequestStatus.COMPLETED, [scanRequest]);
    const scannerNotesAvailable = useMemo(() => scanRequest.reason || scanRequest.comment, [scanRequest]);
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.5 },
        React.createElement(ScanRequestHistoryPopup, { scanRequest: scanRequest }),
        editRequestAvailable || (scannerNotesAvailable && React.createElement(PeekDivider, { orientation: "vertical", light: true })),
        scannerNotesAvailable && React.createElement(ScannerNotesButton, { scanRequest: scanRequest }),
        scannerNotesAvailable && React.createElement(PeekDivider, { orientation: "vertical", light: true }),
        editRequestAvailable && React.createElement(EditRequestButton, { scanRequest: scanRequest })));
};
export default ScanRequestActionCell;
